;
(function(){
  function initRevArrows(vp){
    var track = vp.querySelector('.v9-rev__track');
    var prev  = vp.querySelector('.v9-rev__nav--prev');
    var next  = vp.querySelector('.v9-rev__nav--next');
    if(!track||!prev||!next) return;
    function step(){
      var card = track.querySelector('.v9-rev__card');
      if(!card) return Math.round(track.clientWidth*0.8);
      var gap = parseInt(getComputedStyle(track).columnGap||getComputedStyle(track).gap||'14',10);
      if(isNaN(gap)) gap = 14;
      return card.getBoundingClientRect().width + gap;
    }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left: step(),behavior:'smooth'});});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function boot(){
    var vps = document.querySelectorAll('.v9-rev__viewport');
    for(var i=0;i<vps.length;i++) initRevArrows(vps[i]);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();

/* FF wip397 (2026-08-18): Best Sellers slider prev/next re-sync.
   sections/ff-best-sellers-row.liquid (forked from stock featured-collection.liquid, see
   that file's header comment) renders the SAME unmodified <slider-component> /
   SliderComponent (assets/global.js) carousel every featured-collection row uses --
   nothing about the slider markup, assets/global.js, or assets/component-slider.css was
   changed by this wave. SliderComponent.initPages() computes slidesPerPage/totalPages and
   the prev/next disabled state from each slide's live clientWidth via a ResizeObserver
   that fires as soon as the observer attaches (per spec, using whatever box size is
   available AT THAT MOMENT) then again on later layout changes. Render-verified: on this
   row specifically, both arrows were observed still carrying the disabled attribute after
   the browser's own later ResizeObserver callback had already corrected
   sliderItemsToShow/sliderItemOffset to the right values -- i.e. update()'s own disabled-
   state write happened once and was never re-run against the final, settled layout. Not
   reproducible against snippets/card-product.liquid or template-collection.css (untouched,
   read-only per rules) since disabled-state math lives entirely in assets/global.js, which
   this wave also does not edit. This just re-invokes the SAME initPages() method the
   component already exposes, once more after window 'load' (+ a short delay for any
   late image/font reflow), so the buttons end up reflecting final layout -- same fix a
   user would get from resizing the window by 1px, nothing new is implemented. */
;(function(){
  function resyncBestSellersSlider(){
    var section = document.querySelector('[id*="best_sellers_row"]');
    if (!section) return;
    var sc = section.querySelector('slider-component');
    if (!sc || typeof sc.initPages !== 'function') return;
    sc.initPages();
  }
  function boot(){
    resyncBestSellersSlider();
    setTimeout(resyncBestSellersSlider, 350);
  }
  if (document.readyState === 'complete') { boot(); }
  else { window.addEventListener('load', boot); }
})();
